import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const CommonHelmet = ({...props}) => {
    const title=props.title;
    const description = props.description;
    const canonical = props.canonical;
    console.log(title);
    return (
        <HelmetProvider>
        <Helmet>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <link rel="canonical" href={canonical} />
            {/* Facebook meta */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            {/* Twitter meta */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image:alt" content={title} />
        </Helmet>
        </HelmetProvider>
    );
}

export default CommonHelmet;